import { type FC } from "react"

import { type BlogPost } from "@forento/core/models/dashboard"

import { usePlatform } from "~/contexts/UserContext"

import CreatorCommunityBanner from "./CreatorCommunityBanner"
import CreatorHighlightsBanner from "./CreatorHighlightsBanner"
import ForentoAiBanner, { ForentoAiClaimedBanner } from "./ForentoAiBanner"
import FreeTrial from "./FreeTrial"
import { getDashboardNotice } from "./notices"

type Props = { publishedOfferCount: number; latestHighlight: BlogPost | null }
const DashboardNotice: FC<Props> = ({ publishedOfferCount, latestHighlight }) => {
	const platform = usePlatform()!

	switch (getDashboardNotice({ platform, publishedOfferCount })) {
		case "forento-ai-claimed":
			return <ForentoAiClaimedBanner />
		case "free-trial":
			return <FreeTrial />
		case "creator-highlights":
			return <CreatorHighlightsBanner latestHighlight={latestHighlight} />
		case "creator-community":
			return <CreatorCommunityBanner />
		case "forento-ai-offer":
			return <ForentoAiBanner />
		case null:
			return null
	}
}

export default DashboardNotice
